import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=c807a178&scoped=true&"
import script from "./ProvidersList.vue?vue&type=script&lang=js&"
export * from "./ProvidersList.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=c807a178&lang=scss&scoped=true&"
import style1 from "./ProvidersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c807a178",
  null
  
)

export default component.exports